import { Order } from '@/types';
import { ParsedSku } from '@/utils/parseSku';

const getIsOrderComplete = (order: Order): boolean => {
  if (!order?.lineItems?.length) {
    return false;
  }

  // filter out memberships, etc
  const ringItems = order.lineItems.filter(({ originalSku }) => {
    if (!originalSku) return false; // all rings should have originalSku
    const parsedSku = new ParsedSku(originalSku!);
    return parsedSku.isRing();
  });

  // check for item sku
  return ringItems?.every((item) => Boolean(item.sku));
};

export default getIsOrderComplete;
